import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PinInput from 'react-pin-input';
import CustomNewConfirm from 'components/NewDesign/CustomNewConfirm/CustomNewConfirm';

const PinInputModal = ({
  showPopup,
  closePopup,
  confirmPin,
  pinCode,
  description,
}) => {
  const [formData, setFormData] = useState({
    pin: '',
  });
  const [error, setError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.pin.trim()) {
      setError('Provide a PIN');
      return;
    }
    if (pinCode && formData.pin !== pinCode) {
      setError('Invalid PIN');
      return;
    }
    confirmPin(formData);
  };

  useEffect(() => {
    setFormData({
      pin: '',
    });
  }, [showPopup]);

  return (
    <CustomNewConfirm
      isOpen={showPopup}
      onClose={closePopup}
      title={'Enter PIN code'}
      description={description} // Pass the description to CustomNewConfirm
      onConfirm={handleSubmit}
      confirmButtonText="Confirm"
      showValidationRules={true}
    >
      <form onSubmit={handleSubmit}>
        <PinInput
          length={4}
          initialValue={formData.pin}
          secret
          secretDelay={100}
          onChange={(value, index) => {
            setError(null);
            setFormData({ pin: value });
          }}
          type="numeric"
          inputMode="numeric"
          style={{ marginBottom: '20px', textAlign: 'center' }}
          inputStyle={{ borderColor: 'red' }}
          inputFocusStyle={{ borderColor: 'blue' }}
          onComplete={(value, index) => {}}
          autoSelect={true}
          regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
        />
        {error && (
          <p
            className="error"
            style={{ fontSize: '16px', textAlign: 'center' }}
          >
            {error}
          </p>
        )}
      </form>
    </CustomNewConfirm>
  );
};

PinInputModal.propTypes = {
  showPopup: PropTypes.bool,
  closePopup: PropTypes.func,
  confirmPin: PropTypes.func,
  description: PropTypes.string,
  pinCode: PropTypes.string,
};

export default PinInputModal;
